import { CrawlerImportPayload, normalizeCrawlerCode, normalizeCrawlerImportPayload, normalizeCrawlerPhone } from '../../../domain/entities/Crawler';
import { normalizeCrawlerChannelSelection } from '../../../domain/entities/CrawlerChannel';
import { ICrawlerRepository } from '../../ports/ICrawlerRepository';

export class ListCrawlersUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute() {
    return this.repo.list();
  }
}

export class AddCrawlerUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(phone: string) {
    return this.repo.add(normalizeCrawlerPhone(phone));
  }
}

export class ImportCrawlerUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(payload: Partial<CrawlerImportPayload>) {
    return this.repo.importFromSession(normalizeCrawlerImportPayload(payload));
  }
}

export class RequestCrawlerCodeUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string) {
    return this.repo.requestCode(uuid);
  }
}

export class ConfirmCrawlerCodeUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string, code: string, password: string) {
    return this.repo.confirmCode(uuid, normalizeCrawlerCode(code), password ?? '');
  }
}

export class ReleaseCrawlerUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string) {
    return this.repo.release(uuid);
  }
}

export class ListCrawlerChannelsUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string) {
    return this.repo.listChannels(uuid);
  }
}

export class AssignCrawlerChannelsUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string, channelUuids: string[]) {
    return this.repo.assignChannels(uuid, normalizeCrawlerChannelSelection(channelUuids));
  }
}

export class UnassignCrawlerChannelUseCase {
  constructor(private repo: ICrawlerRepository) {}
  execute(uuid: string, id: number) {
    return this.repo.unassignChannel(uuid, id);
  }
}
